import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as mainApi from "lib/api/main";

// 클릭 많은 연구
const MAIN_DATA = "main/MAIN_DATA";
const MAIN_DATA_PENDING = "main/MAIN_DATA_PENDING";
const MAIN_DATA_SUCCESS = "main/MAIN_DATA_SUCCESS";

const HEALTHY_DATA = "main/HEALTHY_DATA";
const HEALTHY_DATA_SUCCESS = "main/HEALTHY_DATA_SUCCESS";

const DISEASE_DATA = "main/DISEASE_DATA";
const DISEASE_DATA_SUCCESS = "main/DISEASE_DATA_SUCCESS";

export const mainData = createPromiseThunk(MAIN_DATA, mainApi.mainData);
export const healthyStudy = createPromiseThunk(
  HEALTHY_DATA,
  mainApi.healthyStudy
);
export const diseaseStudy = createPromiseThunk(
  DISEASE_DATA,
  mainApi.diseaseStudy
);

const initialState = {
  data: null,
  healthyData: null,
  diseaseData: null
};

export default handleActions(
  {
    [MAIN_DATA_PENDING]: (state, { payload }) => ({ ...state, data: null }),
    [MAIN_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data
    }),
    [HEALTHY_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      healthyData: payload.data
    }),
    [DISEASE_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      diseaseData: payload.data
    })
  },
  initialState
);
